import React from "react";
import { useLocation } from "react-router-dom";

export const statusConditions = [
  {
    title: "Completed",
    description: "Task Completed",
    icon: "completed.png",
  },
  {
    title: "Work in Progress",
    description: "Deadline future date",
    icon: "work-progres.png",
  },
  {
    title: "On Time",
    description: "Delay within 0-7 days",
    icon: "on-time.png",
  },
  {
    title: "Slight Delay",
    description: "Delay within 8-30 days",
    icon: "slight-delay.png",
  },
  {
    title: "Significant Delay",
    description: "Delay Beyond 30 days",
    icon: "significant-delay.png",
  },
];
export default function Footer() {
  debugger
  const location = useLocation();

  // List of paths where footer should be hidden
  const hiddenPaths = ["/dashboard"];

  if (hiddenPaths.includes(location.pathname)) {
  return (
    <div
      className="d-flex flex-wrap justify-content-center mt-2 align-items-center gap-2"
      style={{ paddingBottom: 30 }}
    >
      {statusConditions.map((item, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            paddingLeft: 15,
            paddingRight: 15,
          }}
        >
          <img
            style={{ maxWidth: 60, maxHeight: 60 }}
            src={`${process.env.PUBLIC_URL}/icons/${item.icon}`}
            alt="icon"
            className="mb-2"
          />
          <h1
            style={{ color: "#868686", fontSize: 14, lineHeight: 0.5 }}
            className=""
          >
            {item.title}
          </h1>
          <p style={{ color: "#868686", fontSize: 13, lineHeight: 1 }}>
            {item.description}
          </p>
        </div>
      ))}
    </div>
  );
  }
}
